(() => {
  if (window.deliveryInfoLinksInitialized) return;
  window.deliveryInfoLinksInitialized = true;

  const deliveryInfoSelector = '.delivery-info-icon .product-icon-with-text__text, variant-picker legend.label';
  const productContactFormSelector = '#product-contact-form';
  const emailPattern = '[A-Z0-9._%+-]+@[A-Z0-9.-]+\\.[A-Z]{2,}';
  const phonePattern = '(?:\\+\\d{1,3}\\s?(?:\\(0\\)\\s?)?|0)(?:\\d[\\s().-]?){7,12}\\d';
  const linkPattern = new RegExp(`(${emailPattern})|(${phonePattern})`, 'gi');

  function phoneHref(phoneNumber) {
    const withoutOptionalZero = phoneNumber.replace(/\(0\)/g, '');
    const normalized = withoutOptionalZero.replace(/[^\d+]/g, '');
    return `tel:${normalized}`;
  }

  function linkifyTextNode(textNode) {
    const text = textNode.nodeValue;
    linkPattern.lastIndex = 0;
    if (!linkPattern.test(text)) return;

    linkPattern.lastIndex = 0;
    const fragment = document.createDocumentFragment();
    let lastIndex = 0;
    let match = linkPattern.exec(text);

    while (match) {
      if (match.index > lastIndex) {
        fragment.append(document.createTextNode(text.slice(lastIndex, match.index)));
      }

      const value = match[0];
      const link = document.createElement('a');
      link.className = 'delivery-info-icon__auto-link link';
      link.href = match[1] ? `mailto:${value}` : phoneHref(value);
      link.textContent = value;
      fragment.append(link);

      lastIndex = linkPattern.lastIndex;
      match = linkPattern.exec(text);
    }

    if (lastIndex < text.length) {
      fragment.append(document.createTextNode(text.slice(lastIndex)));
    }

    textNode.replaceWith(fragment);
  }

  function isContactFormLink(link) {
    const href = link.getAttribute('href')?.trim();
    if (!href || href.startsWith('mailto:') || href.startsWith('tel:')) return false;

    try {
      const url = new URL(href, window.location.href);
      const hash = url.hash.toLowerCase();
      const path = url.pathname.replace(/\/$/, '').toLowerCase();

      return hash === '#contact-form'
        || hash === productContactFormSelector
        || path.endsWith('/pages/contact-us');
    } catch (error) {
      return false;
    }
  }

  function routeContactLinksToProductForm(deliveryInfo) {
    if (!document.querySelector(productContactFormSelector)) return;

    deliveryInfo.querySelectorAll('a[href]').forEach((link) => {
      if (!isContactFormLink(link)) return;

      link.setAttribute('href', productContactFormSelector);
      link.removeAttribute('target');
      link.setAttribute('data-delivery-contact', '');
    });
  }

  function linkifyDeliveryInfo(root = document) {
    const deliveryInfoElements = [];

    if (root.matches?.(deliveryInfoSelector)) {
      deliveryInfoElements.push(root);
    }
    deliveryInfoElements.push(...root.querySelectorAll(deliveryInfoSelector));

    deliveryInfoElements.forEach((deliveryInfo) => {
      routeContactLinksToProductForm(deliveryInfo);

      const walker = document.createTreeWalker(deliveryInfo, NodeFilter.SHOW_TEXT, {
        acceptNode(node) {
          if (!node.nodeValue.trim()) return NodeFilter.FILTER_REJECT;
          if (node.parentElement?.closest('a, script, style, textarea')) {
            return NodeFilter.FILTER_REJECT;
          }
          return NodeFilter.FILTER_ACCEPT;
        }
      });
      const textNodes = [];
      let textNode = walker.nextNode();

      while (textNode) {
        textNodes.push(textNode);
        textNode = walker.nextNode();
      }

      textNodes.forEach(linkifyTextNode);
    });
  }

  function openProductContact(event) {
    const link = event.target.closest('[data-backorder-contact], [data-delivery-contact]');
    if (!link) return;

    const formSection = document.querySelector(link.getAttribute('href'));
    if (!formSection) return;
    const sectionTarget = formSection.nextElementSibling?.matches('.contact-form-section')
      ? formSection.nextElementSibling
      : formSection;
    // On mobile the heading and intro can fill the screen, so land on the form.
    const formTarget = window.formAnchorScroll?.resolveTarget(sectionTarget) || sectionTarget;

    event.preventDefault();
    const skuField = formSection.parentElement.querySelector('[data-contact-field="product-sku"]');
    const shouldUpdateSku = skuField && link.hasAttribute('data-product-sku');
    if (shouldUpdateSku) {
      skuField.value = link.dataset.productSku || '';
      skuField.dispatchEvent(new Event('input', { bubbles: true }));
      skuField.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // form-anchor-scroll.js holds the position while the SKU update, the sticky
    // header and lazily loaded sections below resize the page.
    if (window.formAnchorScroll) {
      window.formAnchorScroll.scrollToTarget(formTarget);
    } else {
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      formTarget.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
    }

    window.history.replaceState(null, '', link.getAttribute('href'));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => linkifyDeliveryInfo(), { once: true });
  } else {
    linkifyDeliveryInfo();
  }

  document.addEventListener('on:variant:before-replace-element', (event) => {
    linkifyDeliveryInfo(event.detail?.replaceWith);
  });

  document.addEventListener('on:variant:change', (event) => {
    linkifyDeliveryInfo(event.target.closest('.shopify-section') || document);
  });

  document.addEventListener('click', openProductContact);

  document.addEventListener('shopify:section:load', (event) => {
    linkifyDeliveryInfo(event.target);
  });
})();
